import React, { useState, useEffect, useContext } from 'react';
import { Button, Dropdown, Icon, Popup } from 'semantic-ui-react';
import { InvoiceOperation, InvoiceUtility } from './invoice.utility';
import InvoicePreview from '../../components/secure/provider/invoices/invoice-preview/InvoicePreview';
import EditInvoice from '../../components/secure/provider/invoices/edit-invoice/EditInvoice';
import VirtualTerminalForm from '../../components/secure/provider/transactions/terminals/virtual-terminal/virtual-terminal-form/VirtualTerminalForm';
import AddRecurringPlan from '../../components/secure/provider/transactions/terminals/installment-terminal/AddRecurringPlan';
import SendInvoice from '../../components/secure/provider/invoices/send-invoice/SendInvoice';
import CloseAndWriteOff from '../../components/secure/provider/transactions/close-and-write-off/CloseAndWriteOff';
import ModalBox from '../../components/templates/components/ModalBox';
import InvoiceService from '../api/invoice.service';
import { store } from '../../context/StateProvider';
import './ButtonGroup.scss'
import CancelInvoice from '../../components/secure/provider/transactions/cancel-invoice/CancelInvoice';
const InvoiceButtonGroup = (props) => {
  const state = useContext(store).state

  const [invoiceData, setInvoiceData] = useState(props.initialData || {})
  const [edit, setEdit] = useState(false);
  const [sendInvoice, setSendInvoice] = useState(false);
  const [pay, setPay] = useState(false);
  const [preview, setPreview] = useState(false);
  const [recurringPlan, setRecurringPlan] = useState(false);
  const [recurringPlanType, setRecurringPlanType] = useState(null);
  const [cancel, setCancel] = useState(false);
  const [close, setClose] = useState(false);
  const [cancelWO, setCancelWO] = useState(false);
  const [dropdownItems, setDropdownItems] = useState([]);
  const [showStatusDescription, setShowStatusDescription] = useState(props.showStatusDescription === false ? false : true);

  const [showEdit, setShowEdit] = useState(props.showEdit === false ? false : true);
  const [showSendToPatient, setShowSendToPatient] = useState(props.showSendToPatient === false ? false : true);
  const [showCollectPayment, setShowCollectPayment] = useState(props.showCollectPayment === false ? false : true);
  const [showViewDetails, setShowViewDetails] = useState(props.showViewDetails === false ? false : true);
  const [showSetupPaymentPlan, setShowSetupPaymentPlan] = useState(props.showSetupPaymentPlan === false ? false : true);
  const [showSetupSubscriptionPlan, setShowSetupSubscriptionPlan] = useState(props.showSetupSubscriptionPlan === false ? false : true);
  const [showCancel, setShowCancel] = useState(props.showCancel === false ? false : true);
  const [showClose, setShowClose] = useState(props.showClose === false ? false : true);
  const [showCancelAndWriteOff, setShowCancelAndWriteOff] = useState(props.showCancelAndWriteOff === false ? false : true);
  const [invoice, setInvoice] = useState()
  const [buttonClass, setButtonClass] = useState(`${props.buttonClass ? props.buttonClass : ''} btn btn-primary`)
  const [isLoader, setIsLoader] = useState(false)
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  const invoiceType = [
    { title: 'Standard Invoice', value: 0 }, //Full Payment
    { title: 'Payment Plan', value: 1 },
    { title: 'One Time Scheduled', value: 2 },
    { title: 'Subscription', value: 3 },
    { title: 'Split Payment', value: 4 },
    { title: 'Prepaid Balance', value: 5 },
  ]
  // const ellipsisStyle = {
  //   display: 'flex',
  //   justifyContent: 'center',
  //   alignItems: 'center'
  // };
  useEffect(() => {
    const items = [];

    if (showSetupPaymentPlan && state.permissions.paymentsModifySubscriptionsAndPlans && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.SETUP_PAYMENT_PLAN)) {
      items.push(<Dropdown.Item key="setup-payment-plan" onClick={() => handleRecurringPlan(1)}>Setup Payment Plan</Dropdown.Item>);
    }

    if (showSetupSubscriptionPlan && state.permissions.paymentsModifySubscriptionsAndPlans && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.SETUP_SUBSCRIPTION)) {
      items.push(<Dropdown.Item key="setup-subscription-plan" onClick={() => handleRecurringPlan(3)}>Setup Subscription Plan</Dropdown.Item>);
    }

    if (showCancel && state.permissions.paymentsModifyInvoices && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.CANCEL)) {
      items.push(<Dropdown.Item key="cancel" onClick={handleCancel}>Cancel</Dropdown.Item>);
    }

    if (showClose && state.permissions.paymentsModifyInvoices && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.CLOSE)) {
      items.push(<Dropdown.Item key="close" onClick={handleClose}>Close</Dropdown.Item>);
    }

    if (showCancelAndWriteOff && state.permissions.paymentsModifyInvoices && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.CLOSE_WRITEOFF)) {
      items.push(<Dropdown.Item key="cancel-and-write-off" onClick={handleCancelWO}>Cancel & Write Off</Dropdown.Item>);
    }

    setDropdownItems(items);
  }, []);

  useEffect(() => {
    if (sendInvoice || pay || preview || recurringPlan) {
      if (!invoice) {
        pullInvoice();
      }
    }
  }, [sendInvoice, pay, preview, recurringPlan]);

  const handleEdit = () => {
    setEdit(true);
  };

  const handleSendInvoice = () => {
    setSendInvoice(true);
  };

  const handlePay = () => {
    setPay(true);
  };

  const handlePreview = () => {
    setPreview(true);
  };

  const handleRecurringPlan = (type) => {
    setRecurringPlanType(type);
    setRecurringPlan(true);
    setIsDropDownOpen(false);
  };

  const handleCancel = () => {
    setCancel(true);
    setIsDropDownOpen(false);
  };

  const handleClose = () => {
    setClose(true);
    setIsDropDownOpen(false);
  };

  const handleCancelWO = () => {
    setCancelWO(true);
    setIsDropDownOpen(false);
  };

  const pullInvoice = () => {
    InvoiceService.getInvoiceById(props.invoiceId)
      .then(res => {
        setInvoice(res)
      })
  }

  return (
    <>
      {showStatusDescription && invoiceData?.invoiceStatus && (
        <div className={`${props.buttonClass ? props.buttonClass : ''} pe-1 btn btn-secondary`} title={InvoiceUtility.GetInvoiceStatusDescription(invoiceData?.invoiceStatus)}>
          {(invoiceData?.invoiceType && [1, 2, 3, 5].includes(invoiceData?.invoiceType)) ? (
            invoiceType.find((obj) => obj.value == invoiceData.invoiceType)?.title + ": "
          ) : null}
          {InvoiceUtility.GetInvoiceStatusDescription(invoiceData?.invoiceStatus)}
        </div>
      )}
      {/* pass extra button extraButton={extraButtons} */}
      {props.extraButton && props.extraButton}
      {showEdit && state.permissions.paymentsModifyInvoices && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.UPDATE) ? (
        <button className={buttonClass} title="Edit Invoice" onClick={handleEdit}>
          <i className={`icon pencil`} />
        </button>
      ) : null}

      {showSendToPatient && state.permissions.patientModifyCommunications && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.SEND_TO_PATIENT) ? (
        <button className={buttonClass} title="Send Invoice to Patient" onClick={handleSendInvoice}>
          <i className="icon paper plane outline" />
        </button>
      ) : null}

      {showCollectPayment && state.permissions.paymentsModifyTransactions && InvoiceUtility.OperationAllowed(invoiceData, InvoiceOperation.MAKE_PAYMENT) ? (
        <button className={buttonClass} title="Collect Payment" onClick={handlePay}>
          <i className="icon dollar" />
        </button>
      ) : null}

      {showViewDetails && state.permissions.paymentsViewInvoices ? (
        <button className={buttonClass} title="Invoice Preview" onClick={handlePreview}>
          <i className="icon eye" />
        </button>
      ) : null}
      {dropdownItems.length > 0 && (
        <Popup
          className="no-border-popup"
          trigger={
            <Button
              icon
              className={`${props.buttonClass ? 'btn-primary p-1 m-0' : 'btn-primary'} `}
              style={{ cursor: 'pointer', borderRadius: '0px 5px 5px 0' }}
            >
              <Icon name="ellipsis horizontal" />
            </Button>
          }
          content={
            <Dropdown.Menu className="custom-popup-menu" closePopup={() => setIsDropDownOpen(false)}>
              {dropdownItems}
            </Dropdown.Menu>
          }
          on="click"
          position="top right"
          open={isDropDownOpen}
          onClose={() => setIsDropDownOpen(false)}
          onOpen={() => setIsDropDownOpen(true)}
        />
      )}
      {/* {dropdownItems.length > 0 && (
        <Dropdown button direction="left" icon="ellipsis horizontal" className={`${props.buttonClass ? 'btn-primary icon btn p-1 ps-0 m-0' : 'btn-primary icon btn p-o'}`} style={ellipsisStyle}>
          <Dropdown.Menu>
            {dropdownItems}
          </Dropdown.Menu>
        </Dropdown>
      )} */}
      {preview && (
        <ModalBox open={preview} onClose={() => { setPreview(false) }} title={`Invoice Preview`} size="fullscreen">
          <InvoicePreview invoiceId={props.invoiceId} isModal onClose={() => { setPreview(false) }} />
        </ModalBox>
      )}

      {edit && (
        <ModalBox open={edit} onClose={() => { setEdit(false) }} size="fullscreen" title={`Edit Invoice`}>
          <EditInvoice id={props.invoiceId} onClose={() => { setEdit(false) }} refresh={() => { props.refresh() }} isModal />
        </ModalBox>
      )}

      {pay && invoice && (
        <ModalBox open={pay} onClose={() => { setPay(false) }} title="Collect Payment">
          <VirtualTerminalForm initialData={invoice} invoiceId={props.invoiceId} patientId={invoiceData?.patientId} onClose={() => { setPay(false) }} refresh={() => { props.refresh() }} isModal />
        </ModalBox>
      )}

      {recurringPlan && invoice && (
        <ModalBox open={recurringPlan} onClose={() => { setRecurringPlan(false) }} title={recurringPlanType == 1 ? "Create Payment Plan" : "Subscription"}>
          <AddRecurringPlan initialData={invoice} invoiceId={props.invoiceId} transactionType={recurringPlanType} onClose={() => { setRecurringPlan(false) }} refresh={() => { props.refresh() }} isModal />
        </ModalBox>
      )}

      {sendInvoice && invoice && (
        <ModalBox open={sendInvoice} onClose={() => { setSendInvoice(false) }} size="fullscreen" title="Send Invoice">
          <SendInvoice transaction={invoice} patientId={invoiceData?.patientId} invoiceId={props.invoiceId} onClose={() => { setSendInvoice(false) }} />
        </ModalBox>
      )}

      {cancel && (
        <ModalBox open={cancel} onClose={() => { setCancel(false) }} size="tiny" title="Cancel Invoice">
          <CancelInvoice refresh={() => { props.refresh() }} invoiceId={props.invoiceId} onClose={() => { setCancel(false) }} />
        </ModalBox>
      )}

      {close && (
        <ModalBox open={close} onClose={() => { setClose(false) }} size="tiny" title="Close Invoice">
          <CloseAndWriteOff closeReason={'Close invoice'} refresh={() => { props.refresh() }} invoiceId={props.invoiceId} onClose={() => { setClose(false) }} />
        </ModalBox>
      )}

      {cancelWO && (
        <ModalBox open={cancelWO} onClose={() => { setCancelWO(false) }} size="tiny" title="Close and Write Off">
          <CloseAndWriteOff refresh={() => { props.refresh() }} invoiceId={props.invoiceId} onClose={() => { setCancelWO(false) }} />
        </ModalBox>
      )}
    </>
  );
};

export default InvoiceButtonGroup;